import { createRoot } from "react-dom/client";
import { createInstance, Piral } from "piral";
import { layout, errors } from "./layout";
import { createPageLayoutsApi } from "piral-page-layouts";
import { fetchPiletConfig } from "./api/pilet";
import { ShellData } from "./types/teams";
import { app, authentication } from "@microsoft/teams-js";
import { checkInTeams } from "./services/teams";
import { msalInstance } from "./auth";
import ShellProviders from "./providers/ShellProviders";
import auth from "./api/auth";

async function signIn() {
  const loginRequest = {
    scopes: ["openid", "User.Read"],
  };
  await msalInstance.loginRedirect(loginRequest);
}

function initiatePiletInstance(shellData: ShellData) {
  const instance = createInstance({
    state: {
      shellData: shellData,
      components: layout,
      errorComponents: errors,
      provider: ShellProviders,
    },
    plugins: [createPageLayoutsApi()],
    requestPilets() {
      return fetchPiletConfig(shellData.tenantId, "");
    },
  });

  const root = createRoot(document.querySelector("#app"));

  instance.root.setData("shell-data", shellData);

  root.render(<Piral instance={instance} />);
}

if (checkInTeams()) {
  if (!app.isInitialized()) {
    app.initialize().then(() => {
      app.getContext().then((teamsContext) => {
        const theme = teamsContext.app.theme;
        const username = teamsContext.user.userPrincipalName;
        const tenantId = teamsContext.user.tenant.id;

        const deepLinkContextValue = teamsContext.page.subPageId;
        console.log("Deep link context :", deepLinkContextValue);

        const shellData: ShellData = {
          theme,
          username,
          tenantId,
          isInTeams: true,
          msalInstance,
          authApi: auth,
          teamsAuthenticaton: authentication,
        };

        if (deepLinkContextValue) {
          shellData.deeplinkContext = {
            assignmentId: deepLinkContextValue,
          };
        }

        console.log("shellData");
        console.log(shellData);

        initiatePiletInstance(shellData);
      });
    });
  } else {
    app.getContext().then((teamsContext) => {
      const theme = teamsContext.app.theme;
      const username = teamsContext.user.userPrincipalName;
      const tenantId = teamsContext.user.tenant.id;

      const deepLinkContextValue = teamsContext.page.subPageId;
      console.log("Deep link context :", deepLinkContextValue);

      const shellData: ShellData = {
        theme,
        username,
        tenantId,
        isInTeams: true,
        msalInstance,
        authApi: auth,
        teamsAuthenticaton: authentication,
      };

      if (deepLinkContextValue) {
        shellData.deeplinkContext = {
          assignmentId: deepLinkContextValue,
        };
      }

      console.log("shellData");
      console.log(shellData);

      initiatePiletInstance(shellData);
    });
  }
} else {
  msalInstance.initialize().then(async () => {
    await msalInstance
      .handleRedirectPromise()
      .then((loginResponse) => {
        // Handle login response
        if (loginResponse !== null) {
          const account = msalInstance.getAllAccounts()[0]; // Get the first account
          msalInstance.setActiveAccount(account);

          initiatePiletInstance({
            theme: "light",
            username: loginResponse.account.username,
            tenantId: loginResponse.tenantId,
            isInTeams: false,
            msalInstance,
            authApi: auth,
          });
          // You can now call your API or perform other operations
        } else {
          // Check if there is an account already logged in
          const currentAccount = msalInstance.getAllAccounts()[0];
          if (currentAccount) {
            msalInstance.setActiveAccount(currentAccount);
            initiatePiletInstance({
              theme: "light",
              username: currentAccount.username,
              tenantId: currentAccount.tenantId,
              isInTeams: false,
              msalInstance,
              authApi: auth,
            });
          } else {
            // No user is signed in, initiate the sign-in process
            signIn();
          }
        }
      })
      .catch((error) => {
        // Handle error
        console.error(error);
      });
    const currentAccount = msalInstance.getAllAccounts()[0];
    if (!currentAccount) {
      signIn();
    }
  });
}

export * from "./types/teams";
